// extracted by mini-css-extract-plugin
export var fullGrid = "_3c-3";
export var pdpPreviewContainer = "_3c-1";
export var previewContainer = "_3c-0";
export var togglePreviewContainer = "_3c-2";